export const Cross = ({ className = "" }) => (
  <svg viewBox="0 0 48 64" fill="none" className={className} aria-hidden="true">
    <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
      <line x1="24" y1="7" x2="24" y2="57" />
      <line x1="9" y1="23" x2="39" y2="23" />
    </g>
    <g fill="currentColor">
      <circle cx="24" cy="6" r="3" />
      <circle cx="24" cy="58" r="3" />
      <circle cx="8" cy="23" r="3" />
      <circle cx="40" cy="23" r="3" />
      <circle cx="24" cy="23" r="4.2" />
    </g>
  </svg>
);

export const CrossBar = ({ className = "pt-5 sm:pt-6" }) => (
  <div
    data-testid="cross-bar"
    className={`relative z-20 mx-auto flex max-w-6xl items-center justify-between px-6 ${className}`}
  >
    <Cross data-testid="top-cross-left" className="h-7 w-5 text-primary/60 sm:h-9 sm:w-7" />
    <div className="mx-4 flex flex-1 items-center justify-center gap-3">
      <span className="h-px w-full max-w-[110px] bg-gradient-to-r from-transparent to-primary/30" />
      <Cross data-testid="top-cross-center" className="h-8 w-6 text-primary/80 sm:h-10 sm:w-8" />
      <span className="h-px w-full max-w-[110px] bg-gradient-to-l from-transparent to-primary/30" />
    </div>
    <Cross data-testid="top-cross-right" className="h-7 w-5 text-primary/60 sm:h-9 sm:w-7" />
  </div>
);
